import './Header.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo_edunexus.png';
import Button from '../../components/Button/Button';
import { ButtonProps } from '../../types';

function Header() {
    const hamburguerProps: ButtonProps = {
        id: "mobile-menu-button",
        name: "☰",
        type: "button",
        props: {
            popoverTarget: "mobile-menu",
            className: "mobile-menu-button"
        }
    }

    const headerLinks = [
        { id: "/dashboard", name: "Dashboard" }
    ];

    return (
        <header id="header">
            <nav className="container">
                <div className="logo">
                    <Link to="/" className="link">
                        <img src={logo} alt="Logo" />
                    </Link>
                </div>

                <div className="itens">
                    {headerLinks.map((link) => (
                        <Link key={link.id} to={link.id} className="link">
                            {link.name}
                        </Link>
                    ))}

                    <Link to="/dashboard" className="link">
                        <button
                            className="avatar mobile-menu-button"
                            id="mobile-menu-button"
                            popoverTarget="mobile-menu"
                        >
                            GV
                        </button>
                    </Link>
                </div>
            </nav>

            <div className="mobile-menu-container">
                <div className="logo">
                    <Link to="/" className="link">
                        <img src={logo} alt="Logo" />
                    </Link>
                </div>

                <button
                    className="avatar mobile-menu-button"
                    id="mobile-menu-button"
                    popoverTarget="mobile-menu"
                >
                    GV
                </button>

                <dialog
                    popover="auto"
                    id={hamburguerProps.props.popoverTarget}
                    className="menu"
                >
                    {headerLinks.map((link) => (
                        <Link key={link.id} to={link.id} className="link">
                            {link.name}
                        </Link>
                    ))}

                    <hr className="divider" />

                    <Link to="/dashboard" className="link">
                        <Button id="dashboard" name="Dashboard" />
                    </Link>
                </dialog>
            </div>
        </header>
    );
}

export default Header;